import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import  API_BASE_URL  from "../config/api";

const slides = [
  {
    image: "/images/s1.webp",
    eyebrow: "TIME VALLEY",
    title: "TIMELESS",
    highlight: "ELEGANCE",
    description:
      "Discover refined timepieces designed for those who appreciate precision, character, and timeless style.",
  },
  {
    image: "/images/s2.webp",
    eyebrow: "THE SIGNATURE COLLECTION",
    title: "CRAFTED",
    highlight: "FOR TIME",
    description:
      "A sophisticated collection where contemporary design meets the art of traditional watchmaking.",
  },
];

function Home() {
  const [activeSlide, setActiveSlide] = useState(0);

  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
const [email, setEmail] = useState("");
const [subscribeMessage, setSubscribeMessage] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((previous) => (previous + 1) % slides.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

    useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/products`
        );

        const data = await response.json();

        if (Array.isArray(data)) {
          setProducts(data);
        } else if (Array.isArray(data.products)) {
          setProducts(data.products);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("Home products fetch error:", error);
        setProducts([]);
      } finally {
        setProductsLoading(false);
      }
    };

    fetchProducts();
  }, []);
  
  const slide = slides[activeSlide];

  return (
    <main className="tv-home">

      {/* 
          HERO SECTION
       */}

      <section className="tv-hero">

        <div className="tv-hero-image">
          <img
            src={slide.image}
            alt={`${slide.title} ${slide.highlight}`}
          />
        </div>

        <div className="tv-hero-overlay"></div>

        <div className="tv-hero-glow"></div>

        <div className="tv-hero-container">

          <div className="tv-hero-content">

            <span className="tv-hero-eyebrow">
              {slide.eyebrow}
            </span>

            <div className="tv-hero-line"></div>

            <h1>
              {slide.title}
              <br />
              <span>{slide.highlight}</span>
            </h1>

            <p>
              {slide.description}
            </p>

            <div className="tv-hero-buttons">

              <Link
                to="/shop"
                className="tv-hero-primary"
              >
                Shop Collection
                <span>→</span>
              </Link>

              <Link
                to="/collections"
                className="tv-hero-secondary"
              >
                Explore More
              </Link>

            </div>

          </div>

        </div>

        <div className="tv-hero-controls">

          <div className="tv-hero-counter">
            <span>
              {String(activeSlide + 1).padStart(2, "0")}
            </span>

            <div className="tv-hero-counter-line"></div>

            <span>
              {String(slides.length).padStart(2, "0")}
            </span>
          </div>

          <div className="tv-hero-dots">

            {slides.map((_, index) => (
              <button
                key={index}
                type="button"
                className={
                  activeSlide === index
                    ? "active"
                    : ""
                }
                onClick={() => setActiveSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              ></button>
            ))}

          </div>

        </div>

        <div className="tv-hero-scroll">
          <span>SCROLL TO DISCOVER</span>
          <div className="tv-hero-scroll-line"></div>
        </div>

      </section>


      {/* 
          BRAND INTRODUCTION
       */}

      <section className="tv-brand-intro">

        <div className="tv-brand-intro-container">

          <span className="tv-brand-intro-eyebrow">
            THE TIME VALLEY PHILOSOPHY
          </span>

          <div className="tv-brand-intro-line"></div>

          <h2>
            More Than A Watch.
            <br />
            <span>A Statement Of Time.</span>
          </h2>

          <p>
            Time Valley brings together refined design, timeless
            aesthetics and the spirit of modern watchmaking. Every
            timepiece is created to become part of your story —
            today, tomorrow and beyond.
          </p>

          <Link
            to="/about"
            className="tv-brand-intro-link"
          >
            Discover Our Story
            <span>→</span>
          </Link>

        </div>

      </section>
{/* 
    FEATURED WATCHES
 */}

<section className="tv-featured">

  <div className="tv-featured-container">

    {/* Section Heading */}

    <div className="tv-featured-heading">

      <div className="tv-featured-heading-left">

        <span className="tv-featured-eyebrow">
          THE COLLECTION
        </span>

        <div className="tv-featured-line"></div>

        <h2>
          Featured
          <span> Timepieces</span>
        </h2>

      </div>


      <Link
        to="/shop"
        className="tv-featured-view-all"
      >
        View All Watches
        <span>→</span>
      </Link>

    </div>


    {/* Products */}
<div className="tv-featured-grid">
  {productsLoading ? (
  <div className="tv-products-loading">
    Loading timepieces...
  </div>
) : products.length === 0 ? (
  <div className="tv-products-empty">
    No timepieces available yet.
  </div>
) : (
  products.slice(0, 4).map((product, index) => {
    const productImage = product.image1
      ? product.image1.startsWith("http")
        ? product.image1
        : `${API_BASE_URL}/${product.image1.replace(/^\/+/, "")}`
      : "/images/s1.webp";

    return (
      <Link
  to={`/product/${product.id}`}
  className="tv-watch-card-link"
>
      <article
        className="tv-watch-card"
        key={product.id || product._id || index}
      >
        <div className="tv-watch-image">

          <span className="tv-watch-number">
            {String(index + 1).padStart(2, "0")}
          </span>

          <button
            type="button"
            className="tv-watch-wishlist"
            aria-label="Add watch to wishlist"
          >
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M20.8 8.7c0 5.4-8.8 10.2-8.8 10.2S3.2 14.1 3.2 8.7A4.7 4.7 0 0 1 8 4a5.1 5.1 0 0 1 4 2.1A5.1 5.1 0 0 1 16 4a4.7 4.7 0 0 1 4.8 4.7Z" />
            </svg>
          </button>

          <img
            src={productImage}
            alt={
              product.title ||
              product.name ||
              "Time Valley Watch"
            }
          />

         <Link
  to={`/product/${product.id}`}
  className="tv-watch-quick-view"
>
  Quick View
</Link>

        </div>

        <div className="tv-watch-info">

          <span className="tv-watch-category">
            {product.category ||
              product.collection ||
              "TIME VALLEY COLLECTION"}
          </span>

          <h3>
            {product.title ||
              product.name ||
              "Time Valley Timepiece"}
          </h3>

          <div className="tv-watch-bottom">

            <span className="tv-watch-price">
              Rs : {" "}
              {Number(product.price || 0).toLocaleString()}
            </span>

          <Link
  to={`/product/${product.id}`}
  className="tv-watch-details"
>
  View Details
</Link>

          </div>

        </div>

      </article>
      </Link>
    );
  })
)}
</div>

  </div>

</section>
{/* 
    COLLECTIONS
 */}

<section className="tv-collections">

  <div className="tv-collections-container">

    {/* SECTION HEADING */}
    <div className="tv-collections-heading">

      <div className="tv-collections-heading-left">

        <span className="tv-collections-eyebrow">
          EXPLORE OUR WORLD
        </span>

        <div className="tv-collections-line"></div>

        <h2>
          Discover Our
          <span> Collections</span>
        </h2>

      </div>

      <p>
        Distinctive timepieces crafted around different expressions
        of style, character and timeless elegance.
      </p>

    </div>


    {/* COLLECTION GRID */}
    <div className="tv-collections-grid">

      {/* COLLECTION 01 */}
      <Link
        to="/collections"
        className="tv-collection-card tv-collection-large"
      >

        <div className="tv-collection-image">
          <img
            src="/images/s2.webp"
            alt="Time Valley Signature Collection"
          />
        </div>

        <div className="tv-collection-overlay"></div>

        <div className="tv-collection-content">

          <span className="tv-collection-number">
            01
          </span>

          <span className="tv-collection-category">
            SIGNATURE COLLECTION
          </span>

          <h3>
            Timeless
            <br />
            <span>Signature</span>
          </h3>

          <div className="tv-collection-link">
            Explore Collection
            <span>→</span>
          </div>

        </div>

      </Link>


      {/* COLLECTION 02 */}
      <Link
        to="/collections"
        className="tv-collection-card"
      >

        <div className="tv-collection-image">
          <img
            src="/images/s2.webp"
            alt="Time Valley Heritage Collection"
          />
        </div>

        <div className="tv-collection-overlay"></div>

        <div className="tv-collection-content">

          <span className="tv-collection-number">
            02
          </span>

          <span className="tv-collection-category">
            HERITAGE SERIES
          </span>

          <h3>
            Inspired
            <br />
            <span>By Heritage</span>
          </h3>

          <div className="tv-collection-link">
            Explore Collection
            <span>→</span>
          </div>

        </div>

      </Link>


      {/* COLLECTION 03 */}
      <Link
        to="/collections"
        className="tv-collection-card"
      >

        <div className="tv-collection-image">
          <img
            src="/images/s2.webp"
            alt="Time Valley Modern Collection"
          />
        </div>

        <div className="tv-collection-overlay"></div>

        <div className="tv-collection-content">

          <span className="tv-collection-number">
            03
          </span>

          <span className="tv-collection-category">
            MODERN SERIES
          </span>

          <h3>
           EVERYDAY
            <br />
            <span>LUXURY</span>
          </h3>

          <div className="tv-collection-link">
            Explore Collection
            <span>→</span>
          </div>

        </div>

      </Link>


      {/* COLLECTION 04 */}
      {/* <Link
        to="/collections/prestige"
        className="tv-collection-card"
      >

        <div className="tv-collection-image">
          <img
            src="/images/s2.png"
            alt="Time Valley Prestige Collection"
          />
        </div>

        <div className="tv-collection-overlay"></div>

        <div className="tv-collection-content">

          <span className="tv-collection-number">
            04
          </span>

          <span className="tv-collection-category">
            PRESTIGE SERIES
          </span>

          <h3>
            The
            <br />
            <span>Prestige</span>
          </h3>

          <div className="tv-collection-link">
            Explore Collection
            <span>→</span>
          </div>

        </div> */}

      {/* </Link> */}

    </div>

  </div>

</section>
{/* 
    SIGNATURE EDITORIAL BANNER
 */}

<section className="tv-editorial">

  <div className="tv-editorial-image">
    <img
      src="/images/Art.webp"
      alt="Time Valley Signature Timepiece"
    />
  </div>

  <div className="tv-editorial-overlay"></div>

  <div className="tv-editorial-glow"></div>

  <div className="tv-editorial-container">

    <div className="tv-editorial-content">

      <span className="tv-editorial-eyebrow">
        THE ART OF TIME
      </span>

      <div className="tv-editorial-line"></div>

      <h2>
        Designed For
        <br />
        <span>Those Who Value Time.</span>
      </h2>

      <p>
        Every Time Valley timepiece reflects a balance of
        refined design, enduring character and the quiet
        confidence of timeless craftsmanship.
      </p>

      <Link
        to="/about"
        className="tv-editorial-button"
      >
        Discover The Story
        <span>→</span>
      </Link>

    </div>

  </div>

  <div className="tv-editorial-mark">
    <span>TIME</span>
    <div></div>
    <span>VALLEY</span>
  </div>

</section>
{/* 
    NEWSLETTER / FINAL CTA
 */}

<section className="tv-newsletter">

  <div className="tv-newsletter-circle tv-newsletter-circle-one"></div>
  <div className="tv-newsletter-circle tv-newsletter-circle-two"></div>

  <div className="tv-newsletter-container">

    <div className="tv-newsletter-content">

      <span className="tv-newsletter-eyebrow">
        STAY IN THE MOMENT
      </span>

      <div className="tv-newsletter-line"></div>

      <h2>
        Be Part Of
        <br />
        <span>The Time Valley Story.</span>
      </h2>

      <p>
        Receive exclusive access to new collections, private
        releases and stories from the world of Time Valley.
      </p>

    <form
  className="tv-newsletter-form"
  onSubmit={(e) => {
    e.preventDefault();

    if (!email.trim()) return;

    setSubscribeMessage(
      "Thank you! You have successfully subscribed to Time Valley."
    );

    setEmail("");
  }}
>

        <div className="tv-newsletter-input-wrap">

         <input
  type="email"
  placeholder="Enter your email address"
  aria-label="Email address"
  value={email}
  onChange={(e) => {
    setEmail(e.target.value);
    setSubscribeMessage("");
  }}
  required
/>

          <button type="submit">
            Subscribe
            <span>→</span>
          </button>
{subscribeMessage && (
  <div className="tv-newsletter-success">
    ✓ {subscribeMessage}
  </div>
)}
        </div>

      </form>

      <small className="tv-newsletter-note">
        By subscribing, you agree to receive updates from Time Valley.
      </small>

    </div>

  </div>

</section>


    </main>
  );
}

export default Home;